<template>
  <div>
    <div class="col-md-6">
      <base-input label="Nama individu terlibat:">
        <el-select
          class="select-primary"
          size="large"
          placeholder="Single Select"
          v-model="selects.simple"
          @change="getData()"
        >
          <el-option
            v-for="option in select"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          >
          </el-option>
        </el-select>
      </base-input>
    </div>
    <h4 class="info-text">BAHAGIAN B - Pengumpulan Maklumat</h4>

    <div class="row" style="padding: 1%">
      <div class="col-lg-6" style="border-bottom: solid red">
        <h4 class="info-text">
          B1 - Maklumat Individu Terlibat Dalam Kejadian
        </h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <div class="row">
              <div class="col-md-6">
                <base-input
                  label="Nama"
                  v-model="victim.name"
                  disabled
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  label="No KP / Passport"
                  v-model="victim.kp"
                  disabled
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  label="No Pekerja"
                  @change="updateIncident()"
                  v-model="victim.nopekerja"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="Umur"
                  v-model="victim.age"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="No. Telefon"
                  v-model="victim.telNo"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="Kawasan Kerja"
                  v-model="victim.workarea"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="Skop Kerja"
                  v-model="victim.workscope"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="Penyelia"
                  v-model="victim.supervisor"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Tahun Mula Berkhidmat">
                  <el-date-picker
                    type="year"
                    @change="updateIncident()"
                    v-model="victim.startdate"
                  ></el-date-picker>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Alamat Rumah">
                  <textarea
                    @change="updateIncident()"
                    class="address"
                    v-model="victim.homeaddr"
                  ></textarea>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-lg-6"
        style="
          border-left: solid red;
          border-bottom: solid red;
          padding-bottom: 1%;
        "
      >
        <h4 class="info-text">
          B2 - Maklumat Kenderaan Yang Terlibat (jika berkaitan)
        </h4>
        <div class="row justify-content-center">
          <div class="col-sm-10">
            <div class="row">
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="No Pendaftaran Kenderaan"
                  v-model="victim.vehregno"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="Jenis Kenderaan"
                  v-model="victim.vehtype"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Tarikh Tamat Cukai Jalan">
                  <el-date-picker
                    type="date"
                    @change="updateIncident()"
                    v-model="victim.vehrtaxdate"
                  ></el-date-picker>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Tarikh Tamat PUSPAKOM">
                  <el-date-picker
                    type="date"
                    @change="updateIncident()"
                    v-model="victim.vehpuspadate"
                  ></el-date-picker>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="No. of MC"
                  v-model="victim.noofmc"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  @change="updateIncident()"
                  label="No. of LTI"
                  v-model="victim.nooflti"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Accident Cause">
                  <el-select
                    class="select-primary"
                    size="large"
                    placeholder="Single Select"
                    v-model="victim.accausename"
                    @change="updateIncident()"
                  >
                    <el-option
                      v-for="option in selects.cause"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Accident Class">
                  <el-select
                    class="select-primary"
                    size="large"
                    placeholder="Single Select"
                    v-model="victim.acclassname"
                    @change="updateIncident()"
                  >
                    <el-option
                      v-for="option in selects.class"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 text-center">
        <base-button @click="submit()">Update {{victim.name}} info</base-button>
      </div> -->
      <div class="col-lg-12" style="border-bottom: solid red">
        <h4 class="info-text">B3 - Maklumat Kejadian</h4>
        <div class="row justify-content-center">
          <div class="col-md-6">
            <base-input label="Tarikh Kejadian">
              <el-date-picker
                v-model="victim.indate"
                @change="investigation()"
                type="date"
              ></el-date-picker>
            </base-input>
          </div>
          <div class="col-md-6">
            <base-input label="Masa Kejadian">
              <el-time-picker
                v-model="victim.intime"
                @change="investigation()"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
              <!-- <el-time-select v-model="victim.intime" @change="investigation()" 
                :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
                }"
              ></el-time-select> -->
            </base-input>
          </div>
          <div class="col-md-6">
            <base-input label="Lokasi Kejadian (alamat terperinci)">
              <textarea
                class="address"
                @change="investigation()"
                v-model="victim.inlocationdetail"
              ></textarea>
            </base-input>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <base-input
                  @change="investigation()"
                  label="Keadaan Cuaca"
                  v-model="weathercond"
                ></base-input>
                <base-input
                  @change="investigation()"
                  label="Keadaan Persekitaran"
                  v-model="surrcond"
                ></base-input>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <base-input
              @change="investigation()"
              label="Kecederaan"
              v-model="injury"
            ></base-input>
          </div>
          <div class="col-md-6">
            <base-input
              @change="investigation()"
              label="Kerosakan Harta Benda"
              v-model="propdamage"
              type="number"
            >
            </base-input>
          </div>
          <div class="col-sm-10">
            <base-input
              label="Ringkasan Kejadian (Sebelum, Semasa dan Selepas)"
            >
              <textarea
                @change="investigation()"
                class="huraian"
                v-model="insummary"
              ></textarea>
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <h4 class="text-center" style="margin-top: 1%; margin-bottom: 0%">
          B4 - Maklumat Bergambar
        </h4>
        <p class="text-center" style="font-style: italic; margin-bottom: 3%">
          (Sekurang-kurangnya gambar lokasi kejadian, kecederaan pekerja atau
          orang awam, kerosakan harta benda syarikat atau awam)
        </p>
        <div class="row justify-content-center">
          <div
            class="col-lg-9"
            style="border: black solid; border-radius: 10px; padding-top: 1%"
          >
            <div class="row justify-content-center">
              <div class="col-md-3 text-right">
                <image-upload
                  @change="onImageChange"
                  select-text="Select Image"
                  :src="img"
                  v-model="image"
                />
              </div>
              <div class="col-md-5">
                <textarea
                  class="keterangan"
                  placeholder="Keterangan Gambar"
                  v-model="imgdescription"
                ></textarea>
              </div>
              <div class="col-lg-2">
                <base-button type="green" @click="addpic()">Add</base-button>
              </div>
            </div>
          </div>

          <div class="col-md-12" style="margin-top: 3%">
            <el-table
              :data="link"
              style="border: solid white; border-radius: 10px"
              :header-cell-style="{
                background: 'transparent',
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
              :cell-style="{
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
            >
              <el-table-column
                min-width="100"
                sortable
                align="center"
                label="Gambar"
                property="gambar"
              >
                <div slot-scope="{ row }">
                  <input
                    type="image"
                    :src="row.gambar"
                    width="100"
                    height="100"
                  />
                </div>
                <!-- <img :src="gambar" alt="" width="50" height="50"> -->
              </el-table-column>
              <el-table-column
                min-width="100"
                sortable
                align="center"
                label="Keterangan Gambar"
                property="keteranganGambar"
              >
              </el-table-column>
              <el-table-column :min-width="25" align="right">
                <div slot-scope="props">
                  <el-tooltip content="Edit" placement="bottom" effect="light">
                    <base-button
                      @click="modals = true"
                      @click.native="handleEdit(props.row, props.$index)"
                      class="remove btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip
                    content="Delete"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <modal
            :show.sync="modals"
            footer-classes="content-center"
            type="notice"
          >
            <h3 slot="header" class="modal-title">
              Kemaskini Keterangan Gambar
            </h3>
            <div class="row">
              <div class="col-md-12">
                <!-- content -->
                <form @submit.prevent>
                  <div>
                    <base-input
                      type="text"
                      label="Keterangan Gambar"
                      v-model="keteranganGambar"
                    ></base-input>
                    <base-button
                      class="mt-3"
                      native-type="submit"
                      type="success"
                      @click="save()"
                      >Submit</base-button
                    >
                    <base-button
                      class="mt-3"
                      type="danger"
                      @click.native="modals = false"
                      >Cancel</base-button
                    >
                  </div>
                </form>
              </div>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimePicker,
  TimeSelect,
} from "element-ui";
import { ImageUpload, Modal } from "src/components";
import moment, { utc } from "moment";
import fs from "fs";
import swal from "sweetalert2";

export default {
  components: {
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
    Modal,
  },
  data() {
    return {
      modals: false,
      pic: [],
      data: [],
      keteranganGambar: [],
      images: {
        regular: null,
      },
      img: null,
      // img: null,
      imgdescription: "",
      value1: "",
      tableSiteRoute: [
        {
          siteRoute: "Route A",
        },
        {
          siteRoute: "Route B",
        },
      ],
      index: "",
      model: {
        file: null,
      },
      picdetail: true,
      gambar: null,
      idrecord: "",
      notifier: {
        name: "",
        designation: "",
        org: "",
        phoneno: "",
        add: "",
        roc: "",
        jkkpregno: "",
        other: "",
      },
      victim: {
        incidentid: "",
        name: "",
        dob: "",
        kp: "",
        org: "",
        nopekerja: "",
        nationality: "",
        gender: "",
        occupation: "",
        inlocation: "",
        orgaddr: "",
        comp: "",
        intime: "",
        indate: "",
        reportdate: "",
        age: "",
        telNo: "",
        workarea: "",
        workscope: "",
        supervisor: "",
        startdate: "",
        homeaddr: "",
        vehregno: "",
        vehtype: "",
        vehrtaxdate: "",
        vehpuspadate: "",
        noofmc: "",
        nooflti: "",
        acclassname: "",
        accausename: "",
        inlocationdetail: "",
      },
      tempimg: [],
      medic: {
        name: "",
        designation: "",
        telno: "",
        addr: "",
      },
      doc: {
        diagnosis: "",
        diagnosis_date: "",
        name: "",
        addr: "",
      },
      weathercond: "",
      surrcond: "",
      injury: "",
      propdamage: "",
      insummary: "",
      image: "",
      indetails: "",
      inTime: "",
      inLocation: "",
      jkkp: "",
      instid: "",
      select: [],
      selects: {
        simple: "",
        class: [],
        cause: [],
      },
      link: [],
      tempdata: [],
      editdata: [],
      imagebase64: "",
      pics: [],
      links: "",
      deleteimageid: [],
      intimestamp: "",
    };
  },
  created() {
    this.getAcClass();
    this.getAcCause();
    this.getInstId();
    // this.getImages()
    // this.getinvestigation()
  },
  mounted() {
    this.$root.$on("associateincident", (incidentassociate) => {
      console.log(incidentassociate);
      this.data = incidentassociate;
      this.tempdata = [];
      this.select = [];

      // default data without update
      this.defaultdata();

      for (var j = 0; j < incidentassociate.length; j++) {
        console.log(incidentassociate[j]);
        // for(var i=0; i<this.data.length; i++){
        // if(dataindex[j]===this.data[i].incidentId){
        this.tempdata.push(incidentassociate[j].personInvolved);
        // }
        // }
      }
      this.getinvestigation();

      console.log(this.tempdata);

      // dropdown menu
      let emp = [];
      for (var i = 0; i < this.tempdata.length; i++) {
        if (emp.indexOf(this.tempdata[i] === -1)) {
          emp.push(this.tempdata[i]);
        }
      }

      for (var i = 0; i < emp.length; i++) {
        let obj = {
          label: emp[i],
          value: emp[i],
        };
        this.select.push(obj);
      }
    });
    // this.getAssociateIncident();
    // this.$root.$on('updateinvestigation', dataindex =>{
    //   console.log(dataindex)
    //
    // })
  },
  methods: {
    updateIncident() {
      console.log(this.victim.name);
      console.log(this.victim.incidentid);
      console.log(this.victim.age);
      console.log(this.victim.telNo);
      console.log(this.victim.nopekerja);
      console.log(this.victim.workarea);
      console.log(this.victim.workscope);
      console.log(this.victim.supervisor);
      console.log(this.victim.startdate);
      console.log(this.victim.homeaddr);
      console.log(this.victim.vehregno);
      console.log(this.victim.vehtype);
      console.log(this.victim.vehrtaxdate);
      console.log(this.victim.vehpuspadate);
      console.log(this.victim.noofmc);
      console.log(this.victim.nooflti);
      console.log(this.victim.accausename);
      console.log(this.victim.acclassname);
      console.log(this.selects.cause);
      console.log(this.selects.class);
      console.log(this.victim.homeaddr);
      console.log(this.victim.indate);
      console.log(this.victim.intime);

      // let incidentdate = new Date(this.victim.indate).toISOString().slice(0,10);

      // //calculate time stamp
      // let tmstamp = moment(incidentdate + " " + this.victim.intime).format('YYYY-MM-DDTHH:mm:ss')
      // console.log(tmstamp)
      let roadtax = moment(this.victim.vehrtaxdate).format("YYYY-MM-DD");
      let puspakom = moment(this.victim.vehpuspadate).format("YYYY-MM-DD");
      console.log(roadtax);
      console.log(puspakom);

      for (var i = 0; i < this.selects.cause.length; i++) {
        if (this.victim.accausename === this.selects.cause[i].label) {
          this.victim.accausename = this.selects.cause[i].value;
        }
      }
      for (var i = 0; i < this.selects.class.length; i++) {
        if (this.victim.acclassname === this.selects.class[i].label) {
          this.victim.acclassname = this.selects.class[i].value;
        }
      }

      let startdate = moment(this.victim.startdate).format("YYYY");
      console.log(startdate);
      // console.log(this.imagebase64)

      // let desc =""
      // for(var i=0; i<this.pic.length; i++){
      //   desc = this.pic.keteranganGambar
      // }

      //calculate time stamp
      // let timestamp = this.victim.indate + " " + this.victim.intime
      // let utctimestamp = moment(timestamp).utc()
      // var utctimestamp = new Date(timestamp)
      // var tmstamp = utctimestamp.toISOString();
      // console.log(tmstamp)

      let investigation = {
        InstId: this.instid,
        incidentid: parseInt(this.victim.incidentid),
        vicname: this.victim.name,
        age: this.victim.age,
        nopekerja: this.victim.nopekerja,
        telno: this.victim.telNo,
        workarea: this.victim.workarea,
        workscope: this.victim.workscope,
        supervisor: this.victim.supervisor,
        startdate: startdate,
        homeaddr: this.victim.homeaddr,
        vehregno: this.victim.vehregno,
        vehtype: this.victim.vehtype,
        vehrtax: roadtax,
        vehpuspa: puspakom,
        noofmc: this.victim.noofmc,
        nooflti: this.victim.nooflti,
        accausename: parseInt(this.victim.accausename),
        acclassname: parseInt(this.victim.acclassname),
        // intimestamp: tmstamp,
      };
      console.log(investigation);

      var index = -1;
      for (var i = 0; i < this.editdata.length; i++) {
        if (this.editdata[i].vicname === investigation.vicname) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.editdata.splice(index, 1, investigation);
      } else {
        this.editdata.push(investigation);
      }
      console.log(this.editdata);

      // tukar data v-model
      for (var i = 0; i < this.data.length; i++) {
        if (this.selects.simple === this.data[i].personInvolved) {
          this.data[i].personInvolved;
          // this.instid = this.data[i].instid
          this.data[i].incidentid = investigation.incidentid;
          this.data[i].vicAge = investigation.age;
          this.data[i].vicTelNo = investigation.telno;
          this.data[i].NoPekerja = investigation.nopekerja;
          this.data[i].vicWorkArea = investigation.workarea;
          this.data[i].vicWorkScope = investigation.workscope;
          this.data[i].vicSupervisor = investigation.supervisor;
          this.data[i].vicStartDate = investigation.startdate;
          this.data[i].vicHomeAddr = investigation.homeaddr;
          this.data[i].vehRegNo = investigation.vehregno;
          this.data[i].vehType = investigation.vehtype;
          this.data[i].vehRtaxDate = investigation.vehrtax;
          this.data[i].vehPuspaDate = investigation.vehpuspa;
          this.data[i].noOfMc = investigation.noofmc;
          this.data[i].noOfLti = investigation.nooflti;
          this.data[i].acCauseName = this.victim.accausename;
          this.data[i].acClassName = this.victim.acclassname;
        }
      }
    },
    defaultdata() {
      console.log(this.data);
      console.log(this.data.length);
      this.editdata = [];

      for (var i = 0; i < this.data.length; i++) {
        let accausename = "";
        let acclassname = "";
        for (var j = 0; j < this.selects.cause.length; j++) {
          if (this.data[i].acCauseName === this.selects.cause[j].label) {
            accausename = this.selects.cause[j].value;
          }
        }

        for (var j = 0; j < this.selects.class.length; j++) {
          if (this.data[i].acClassName === this.selects.class[j].label) {
            acclassname = this.selects.class[j].value;
          }
        }
        console.log(accausename);
        console.log(acclassname);

        let investigation = {
          InstId: this.data[i].instid,
          incidentid: parseInt(this.data[i].incidentid),
          vicname: this.data[i].personInvolved,
          age: this.data[i].vicAge,
          telno: this.data[i].vicTelNo,
          nopekerja: this.data[i].NoPekerja,
          workarea: this.data[i].vicWorkArea,
          workscope: this.data[i].vicWorkScope,
          supervisor: this.data[i].vicSupervisor,
          startdate: this.data[i].vicStartDate,
          homeaddr: this.data[i].vicHomeAddr,
          vehregno: this.data[i].vehRegNo,
          vehtype: this.data[i].vehType,
          vehrtax: this.data[i].vehRtaxDate,
          vehpuspa: this.data[i].vehPuspaDate,
          noofmc: this.data[i].noOfMc,
          nooflti: this.data[i].noOfLti,
          accausename: parseInt(accausename),
          acclassname: parseInt(acclassname),
          intimestamp: this.data[i].intimestamp,
        };
        this.editdata.push(investigation);
      }
      console.log(this.editdata);

      // console.log(this.imagebase64)

      // let desc =""
      // for(var i=0; i<this.pic.length; i++){
      //   desc = this.pic.keteranganGambar
      // }

      // //calculate time stamp
      // let timestamp = this.victim.indate + " " + this.victim.intime
      // // let utctimestamp = moment(timestamp).utc()
      // var utctimestamp = new Date(timestamp)
      // var tmstamp = utctimestamp.toISOString();
      // console.log(tmstamp)

      // let investigation = {
      //   InstId : this.instid,
      //   incidentid : parseInt(this.victim.incidentid),
      //   vicname: this.victim.name,
      //   age: this.victim.age,
      //   telno: this.victim.telNo,
      //   workarea: this.victim.workarea,
      //   workscope: this.victim.workscope,
      //   supervisor: this.victim.supervisor,
      //   startdate: this.victim.startdate,
      //   homeaddr: this.victim.homeaddr,
      //   vehregno: this.victim.vehregno,
      //   vehtype: this.victim.vehtype,
      //   vehrtax: this.victim.vehrtax,
      //   vehpuspa: this.victim.vehpuspa,
      //   noofmc: this.victim.noofmc,
      //   nooflti: this.victim.nooflti,
      //   accausename: parseInt(this.victim.accausename),
      //   acclassname: parseInt(this.victim.acclassname),
      //   intimestamp: tmstamp,

      // }

      // var index = -1
      // for(var i=0; i<this.editdata.length; i++){
      //   if(this.editdata[i].vicname === investigation.vicname){
      //     index = i
      //     break
      //   }
      // }
      // if(index !== -1){
      //   this.editdata.splice(index,1,investigation)
      // } else {
      //   this.editdata.push(investigation)
      // }
      // console.log(this.editdata)
    },
    getInstId() {
      this.$root.$on("instid", (instid) => {
        console.log(instid);
        this.instid = instid;
        this.getImages();
      });
      console.log(this.instid);
    },
    onFileChange(file) {
      this.file = file;
    },
    validate() {
      let images = this.tempimg;
      let deleteimage = this.deleteimageid;
      // let data = this.data
      console.log(this.pic);
      console.log(this.tempimg);
      let data = this.editdata;
      let pic = this.pic;
      console.log(this.editdata);
      this.$root.$emit("imagedata", images);
      this.$root.$emit("fourthstep", data);
      this.$root.$emit("deleteimage", deleteimage);
      this.$root.$emit("updateimageketerangan", pic);

      // intimestamp update
      let format = "YYYY-MM-DD";
      let format2 = "HH:mm:ss";
      let incidentdate = moment(this.victim.indate, format).format(format);
      let incidenttime = moment(this.victim.intime, format2).format(format2);
      console.log(incidentdate);
      console.log(incidenttime);
      //calculate time stamp
      let a = incidentdate + " " + incidenttime;
      let tmstamp = moment(a).format("YYYY-MM-DDTHH:mm:ss");
      console.log(tmstamp);

      let investigatordata = {
        intimestamp: tmstamp,
        // indate: this.victim.indate,
        // intime: this.victim.intime,
        inlocationdetail: this.victim.inlocationdetail,
        weather: this.weathercond,
        surr: this.surrcond,
        injury: this.injury,
        propdamage: this.propdamage,
        insummary: this.insummary,
      };
      // this.investigator.push(investigatordata)
      console.log(investigatordata);

      this.$root.$emit("investigatordata", investigatordata);
      // this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    },
    onImageChange(file) {
      this.images.regular = file;
      console.log(this.image);
      console.log(file.name);
      this.img = file.name;
      console.log(file);
      // this.imagebase64 = file
      const reader = new FileReader();

      reader.onload = (event) => {
        file = event.target.result;
        console.log(file);
        // rebuild cropperjs with the updated source
        // this.$refs.cropper.replace(event.target.result)
        file.replace(event.target.result);
        console.log(file);
        this.imagebase64 = file;
      };
      reader.readAsDataURL(file);

      console.log(this.imagebase64);

      // console.log(this.$refs.cropper)
      // console.log(this.imagebase64)

      // console.log(reader.readAsDataURL(imagedata[i].imagefile))
      // console.log(imagedata[i].imagefile.toString())
      // imagedesc= imagedata[i].imagedata

      // const fs = require('fs');
      // let img = this.img.toDataURL()
      // console.log(reader.readAsDataURL(file))
      // console.log("'./" + img + "'")
      // var imageAsBase64 = fs.readFileSync("'./" + img + "'");
      // console.log(imageAsBase64)
    },
    handleDelete(index, row) {
      console.log(row);
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(index, row);
          swal({
            title: "Deleted!",
            text: `You deleted image`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    handleEdit(row, index) {
      console.log(row);
      this.gambar = `${row.gambar}`;
      this.keteranganGambar = `${row.keteranganGambar}`;
      this.links = `${row.link}`;
      this.index = index;
    },
    save() {
      console.log(this.link);
      console.log(this.pic);

      let datas = {
        gambar: this.gambar,
        keteranganGambar: this.keteranganGambar,
        link: this.links,
      };
      console.log(datas);
      // update data
      this.link[this.index].keteranganGambar = datas.keteranganGambar;
      this.pic[this.index].keteranganGambar = datas.keteranganGambar;
      // this.links = datas.link
      // this.link.splice(datas.link,1)

      // if(this.gambar === datas.gambar){
      //   this.link.splice(this.gambar,1,datas)
      // }

      // let send = {
      //   gambar: this.links,
      //   keteranganGambar: this.keteranganGambar
      // }
      // if(this.gambar === send.gambar){
      // this.pic.splice(this.send,1,send)
      // }

      this.modals = false;
      this.keteranganGambar = "";
      this.gambar = "";
      this.links = "";
    },
    deleteRow(index, row) {
      console.log(row);
      console.log(index);
      // console.log(this.tempimg)
      this.pic.splice(index, 1);
      this.link.splice(index, 1);
      console.log(row.gambar);
      this.tempimg.splice(row.gambar, 1);
      console.log(this.tempimg);
      if (row.gambar != "") {
        let data = {
          gambar: row.gambar,
        };
        console.log(data);

        // this.$http.post(":9994/api/v1/incident/image/" + this.instid, data)
        //   .then(res=>{
        //     if(!res.error){
        //       let response = res.message
        //       console.log(response)
        //     }
        //   })
      }

      // send deleted image id
      this.deleteimageid.push(row.link);
      console.log(this.deleteimageid);
    },
    getData() {
      console.log(this.selects.simple);
      for (var i = 0; i < this.data.length; i++) {
        if (this.selects.simple === this.data[i].personInvolved) {
          this.victim.name = this.data[i].personInvolved;
          // this.instid = this.data[i].instid
          this.victim.incidentid = this.data[i].incidentid;
          this.victim.kp = this.data[i].vicKp;
          this.victim.nopekerja = this.data[i].NoPekerja;
          this.victim.age = this.data[i].vicAge;
          this.victim.telNo = this.data[i].vicTelNo;
          this.victim.workarea = this.data[i].vicWorkArea;
          this.victim.workscope = this.data[i].vicWorkScope;
          this.victim.supervisor = this.data[i].vicSupervisor;
          this.victim.startdate = this.data[i].vicStartDate;
          this.victim.homeaddr = this.data[i].vicHomeAddr;
          this.victim.vehregno = this.data[i].vehRegNo;
          this.victim.vehtype = this.data[i].vehType;
          this.victim.vehrtaxdate = this.data[i].vehRtaxDate;
          this.victim.vehpuspadate = this.data[i].vehPuspaDate;
          this.victim.noofmc = this.data[i].noOfMc;
          this.victim.nooflti = this.data[i].noOfLti;
          this.victim.accausename = this.data[i].acCauseName;
          this.victim.acclassname = this.data[i].acClassName;
        }
      }
    },
    getinvestigation() {
      console.log(this.data);
      // for(var i=0; i<this.data.length; i++){

      // }
      this.victim.intime = moment(this.data[0].inTime, "HH:mm:ss");
      this.victim.indate = this.data[0].dateOfIncident;
      this.victim.inlocationdetail = this.data[0].inLocation;
      this.weathercond = this.data[0].weatherCond;
      this.surrcond = this.data[0].surrCond;
      this.injury = this.data[0].injury;
      this.propdamage = this.data[0].propDamage;
      this.insummary = this.data[0].inSummry;
      this.intimestamp = this.data[0].intimestamp;
    },
    getImages() {
      console.log(this.instid);
      this.pic = [];
      this.link = [];
      this.$http
        .get(":9994/api/v1/incident/images/" + this.instid)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let data = {
                gambar: response[i].ImageFile,
                keteranganGambar: response[i].ImageDesc,
              };

              let pic = {
                gambar:
                  process.env.VUE_APP_API_URL +
                  ":9994/images/" +
                  response[i].ImageFile,
                // gambar: "data:image/jpeg;base64," + response[i].ImageFile,
                link: response[i].ImageFile,
                keteranganGambar: response[i].ImageDesc,
              };

              this.link.push(pic);
              console.log(pic);
              console.log(response[i].ImageFile);
              // http://dhes.vectolabs.com/
              // this.gambar = process.env.VUE_APP_API_URL + ":9994/images/" + response[i].ImageFile
              // this.keteranganGambar.push(response[i].ImageFile)
              this.pic.push(data);
              console.log(this.gambar);
            }
            console.log(this.link);
          }
        });
    },
    getAcClass() {
      this.$http.get(":9994/api/v1/incident/classname").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let data = {
              label: response[i].AcClassName,
              value: response[i].AcClassId,
            };

            this.selects.class.push(data);
          }
        }
      });
    },
    getAcCause() {
      this.$http.get(":9994/api/v1/incident/causename").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let data = {
              label: response[i].AcCauseName,
              value: response[i].AcCauseId,
            };

            this.selects.cause.push(data);
          }
        }
      });
    },
    investigation() {
      console.log(this.victim.inlocationdetail);
      console.log(this.weathercond);
      console.log(this.surrcond);
      console.log(this.injury);
      console.log(this.propdamage);
      console.log(this.insummary);
      console.log(this.victim.intime);
      console.log(this.victim.indate);
    },
    submit() {
      console.log(this.victim.name);
      console.log(this.victim.incidentid);
      console.log(this.victim.age);
      console.log(this.victim.telNo);
      console.log(this.victim.workarea);
      console.log(this.victim.workscope);
      console.log(this.victim.supervisor);
      console.log(this.victim.startdate);
      console.log(this.victim.homeaddr);
      console.log(this.victim.vehregno);
      console.log(this.victim.vehtype);
      console.log(this.victim.vehrtax);
      console.log(this.victim.vehpuspa);
      console.log(this.victim.noofmc);
      console.log(this.victim.nooflti);
      console.log(this.victim.accausename);
      console.log(this.victim.acclassname);
      console.log(this.selects.cause);
      console.log(this.selects.class);

      for (var i = 0; i < this.selects.cause.length; i++) {
        if (this.victim.accausename === this.selects.cause[i].label) {
          this.victim.accausename = this.selects.cause[i].value;
        }
      }
      for (var i = 0; i < this.selects.class.length; i++) {
        if (this.victim.acclassname === this.selects.class[i].label) {
          this.victim.acclassname = this.selects.class[i].value;
        }
      }

      console.log(this.imagebase64);

      let desc = "";
      for (var i = 0; i < this.pic.length; i++) {
        desc = this.pic.keteranganGambar;
      }

      //calculate time stamp
      let timestamp = this.victim.indate + " " + this.victim.intime;
      // let utctimestamp = moment(timestamp).utc()
      var utctimestamp = new Date(timestamp);
      var tmstamp = utctimestamp.toISOString();
      console.log(tmstamp);

      let investigation = {
        InstId: this.instid,
        incidentid: parseInt(this.victim.incidentid),
        vicname: this.victim.name,
        age: this.victim.age,
        telno: this.victim.telNo,
        workarea: this.victim.workarea,
        workscope: this.victim.workscope,
        supervisor: this.victim.supervisor,
        startdate: this.victim.startdate,
        homeaddr: this.victim.homeaddr,
        vehregno: this.victim.vehregno,
        vehtype: this.victim.vehtype,
        vehrtax: this.victim.vehrtax,
        vehpuspa: this.victim.vehpuspa,
        noofmc: this.victim.noofmc,
        nooflti: this.victim.nooflti,
        accausename: parseInt(this.victim.accausename),
        acclassname: parseInt(this.victim.acclassname),
        intimestamp: tmstamp,
      };

      var index = -1;
      for (var i = 0; i < this.editdata.length; i++) {
        if (this.editdata[i].vicname === investigation.vicname) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.editdata.splice(index, 1, investigation);
      } else {
        this.editdata.push(investigation);
      }
      console.log(this.editdata);
      // this.sendfourthstep(this.editdata)

      swal({
        title: "Successfull!",
        text: this.victim.name + " information succefully saved",
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill",
        confirmButtonText: "Okay",
        buttonsStyling: false,
      });

      // image: this.imagebase64,
      // imgdesc: desc
    },
    sendfourthstep(data) {
      this.$root.$emit("fourthstep", data);
    },
    // passimage(){

    // },
    addpic() {
      this.pics.push(this.imagebase64);
      console.log(this.image);
      console.log(this.imgdescription);
      let data = {
        gambar: this.imagebase64,
        keteranganGambar: this.imgdescription,
      };
      // this.gambar = process.env.VUE_APP_API_URL + ":9994/images/" + this.image
      // this.pic.push(data)
      this.link.push(data);
      console.log(this.pics);
      console.log(data);
      let img = [];

      // for(var i=0; i<this.pics.length; i++){
      console.log(this.imagebase64);
      let imagedata = {
        // imagefile : "/9j/"+ this.imagebase64.substr(23),
        imagefile: this.imagebase64,
        imagedesc: this.imgdescription,
      };
      this.tempimg.push(imagedata);
      console.log(this.tempimg);

      // this.passimage()
      // }

      this.img = null;
      this.imgdescription = "";
    },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.keterangan {
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
